"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return PageTitle;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _core = require("@mantine/core");
var _index = require("../../assets/icons/index");
function PageTitle(param) {
    var title = param.title, onClickBack = param.onClickBack, variant = param.variant, _param_fullwhite = param.fullwhite, fullwhite = _param_fullwhite === void 0 ? false : _param_fullwhite;
    return /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Box, {
        component: "header",
        style: {
            display: "flex",
            paddingTop: "5px",
            alignItems: "center",
            fontSize: "1.2rem",
            padding: "10px 0px"
        },
        children: [
            /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Box, {
                onClick: onClickBack,
                style: {
                    background: "" + (fullwhite ? "#FFFFFF" : "transparent"),
                    borderRadius: 8,
                    width: 40,
                    height: 40,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginRight: 16
                },
                children: /*#__PURE__*/ (0, _jsxruntime.jsx)(_index.ChevronLeft, {
                    color: variant === "white" ? "#FFFFFF" : "#000000"
                })
            }),
            /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Title, {
                size: 14,
                style: {
                    width: "200px",
                    margin: "0 auto",
                    color: variant === "white" ? "#FFFFF" : "#000000"
                },
                children: title
            })
        ]
    });
}
